"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _context = require("../../../../../services/currency/context");
var _Currency = require("../../../../../records/Currency");
var _context2 = require("../../../../../services/log/context");
var _events = require("../../../../../consts/events");
var _SelectableTile = _interopRequireDefault(require("../SelectableTile"));
var _Grid = _interopRequireDefault(require("../Grid"));
var _jsxRuntime = require("react/jsx-runtime");
var _div;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CurrencySelect = _ref => {
  let {
    currencyId,
    setCurrency
  } = _ref;
  const {
    available
  } = (0, _context.useCurrency)();
  const availableList = (0, _Currency.getAvailableList)(available);

  // Ensure that the selected currency is always the first
  const selectedCurrencyIndex = availableList.findIndex(currency => currency.id === currencyId);
  if (selectedCurrencyIndex > 0) {
    const selectedCurrency = availableList[selectedCurrencyIndex];
    availableList.splice(selectedCurrencyIndex, 1);
    availableList.unshift(selectedCurrency);
  }
  const {
    log
  } = (0, _context2.useLog)();
  const onSetCurrency = value => {
    // TODO: check for #top-initiative-trusted-data considerations
    log(_events.REGIONAL_SETTINGS_CURRENCY_CHANGE, {
      actionOrigin: "navbar",
      originalCurrency: currencyId,
      newCurrency: value
    });
    setCurrency(value);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [_div || (_div = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "hidden tb:block tb:pb-300",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        size: "large",
        type: "secondary",
        weight: "medium",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.market_settings_modal.choose_currency"
        })
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
      children: availableList.map(currency => /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectableTile.default, {
        dataTest: "currency-tile",
        title: currency.name,
        options: currency.code,
        selected: currency.id === currencyId,
        onSelect: () => onSetCurrency(currency.id)
      }, currency.code))
    })]
  });
};
var _default = exports.default = CurrencySelect;